import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Translate from 'react-translate-component';
import { Dropdown, Menu } from 'antd';
import { append, compose, equals, reduce } from 'ramda';
import cx from 'classnames';

import { defaultSort } from 'constants/defaultSorts';
import CustomIcon from 'components/common/CustomIcon';

const getSortString = (field, order) => `sort.${field}.${order}`;
const isNotDefault = (current, def) => !equals(current, def);

export default class DropdownSort extends Component {
    static propTypes = {
        sort: PropTypes.object,
        setSort: PropTypes.func.isRequired,
        sortFields: PropTypes.array.isRequired
    }

    getItem(field, order) {
        const fieldKey = getSortString(field, order);

        return (
            <Menu.Item key={ fieldKey }>
                <Translate content={ fieldKey }
                           component='a'
                           onClick={() => this.setSort(field, order) } />
            </Menu.Item>
        );
    }

    setSort(firstField, firstOrder) {
        this.handleVisible();

        this.props.setSort({
            firstField,
            firstOrder
        });
    }

    getSortMenu(selectedKeys) {
        const { sortFields } = this.props;

        const sortItems = reduce((items, field) => {
            return compose(
                append(this.getItem(field, 'dec')),
                append(this.getItem(field, 'inc'))
            )(items);
        }, [], sortFields);

        return (
            <Menu selectedKeys={ [selectedKeys] }>
                <Menu.Item className="text-right" disabled>
                    <Translate content='sort.title' component='span' />
                </Menu.Item>
                { sortItems }
            </Menu>
        );
    }

    handleVisible = (visible) => {
        this.dropdown.classList.toggle('open', visible);
    }

    render() {
        const { sort } = this.props;
        const selectedKeys = getSortString(sort.firstField, sort.firstOrder);

        return (
            <span ref={(node) => this.dropdown = node}>
                <Dropdown trigger={['click']}
                          placement='bottomRight'
                          getPopupContainer={() => this.dropdown}
                          onVisibleChange={ this.handleVisible }
                          overlay={ this.getSortMenu(selectedKeys) }>
                    <a><CustomIcon type="sort" className={cx({'filter-icon-not-default': isNotDefault(sort, defaultSort)})} /></a>
                </Dropdown>
            </span>
        );
    }
}
